// extracted by mini-css-extract-plugin
module.exports = {"userUid":"UserUID_userUid__JYlRq"};